import Image from 'next/image'
import ErrorText from '../ErrorText'
import styles from './style.module.scss'

export default function Dropdown({ options, onChange, value, error, errorMessage }) {
  return (
    <div className={styles.container}>
      <select
        className={error ? styles.form_dropdown_error : styles.form_dropdown}
        value={value}
        onChange={e => {
          onChange && onChange(e.target.value)
        }}>
        <option value="">--</option>
        {options.map((option, i) => (
          <option key={i} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {error && <ErrorText errorMessage={errorMessage} />}
    </div>
  )
}
